import React, { useEffect, useState } from "react";
import "./GroupLoansLateFeePayments.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import CloseIcon from "@mui/icons-material/Close";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansLateFeePayments = ({ selectedLateFee, setLateFeesListView, selectedMemberName }) => {
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [paymentsListView, setPaymentsListView] = useState(null);
    const [paymentsArray, setPaymentsArray] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState([]);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    useEffect(()=>{
        console.log("GroupLoansLateFeePayments------------",selectedLateFee)
        getListOfPayments();
    },[selectedLateFee]);

    const getListOfPayments = async() => {
        try {
            const response = await commonRunQuery(297, selectedLateFee?.loanlatefees?.latefeeid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArr = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setPaymentsArray(loansArr);
              console.log("getListOfPayments_response==========",loansArr);
            } else {
                setPaymentsArray([]);
            }
        } catch (error) {
            console.log("getListOfPayments_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const columns = [
        {
            label: 'Payment Id',
            getValue: (row) => row?.loanlatefeesapplied?.paymentid ?? ''
        },
        {
            label: 'Apply Id',
            getValue: (row) => row?.loanlatefeesapplied?.applyid ?? ''
        },
        {
            label: 'Amount Applied',
            getValue: (row) => row?.loanlatefeesapplied?.amountapplied  ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Late Fee Id',
            getValue: (row) => row?.loanlatefeesapplied?.latefeeid ?? ''
        },
        {
            label: 'Status',
            getValue: (row) => row?.loanlatefeesapplied?.status == "1" ? "Confirmed" : "Not Confirmed"
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedPayment(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                paymentsListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        Late Fee Payments - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLateFeesListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                paymentsListView == null && <Box className="mt-4">
                    <GroupLoansTable
                        data={paymentsArray} 
                        columns={columns} 
                        title="Payment Applied Late Fees" 
                        formatRow={(row) => [
                            row.id,
                            row.record?.BorrowerName,
                            row.name,
                            row.balance,
                            row.record?.DaysPastDue,
                            row.record?.AmountDue
                        ]} 
                        viewMenu={true}
                        handleMenuOpen={handleMenuOpen}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedPayment && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Apply ID", value: selectedPayment?.loanlatefeesapplied?.applyid },
                                            { label: "Late Fee ID", value: selectedPayment?.loanlatefeesapplied?.latefeeid },
                                            { label: "User ID", value: selectedPayment?.loanlatefeesapplied?.userid },
                                            { label: "Payment ID", value: selectedPayment?.loanlatefeesapplied?.paymentid },
                                            { label: "Confirmation Time", value: selectedPayment?.loanlatefeesapplied?.confirmationtime || "N/A" },
                                            { label: "Confirmation Ref No", value: selectedPayment?.loanlatefeesapplied?.confirmationrefno || "N/A" },
                                            { label: "Currency Code", value: selectedPayment?.loanlatefeesapplied?.currcode || "N/A" },
                                            { label: "Status", value: selectedPayment?.loanlatefeesapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Amount Applied", value: selectedPayment?.loanlatefeesapplied?.amountapplied },
                                            { label: "Tax Amount Breakdown", value: selectedPayment?.loanlatefeesapplied?.taxamountbreakdown },
                                            { label: "Fee System Breakdown", value: selectedPayment?.loanlatefeesapplied?.feesystembreakdown },
                                            { label: "Fee External Breakdown", value: selectedPayment?.loanlatefeesapplied?.feeexternalbreakdown },
                                            { label: "Fee Franchisee Breakdown", value: selectedPayment?.loanlatefeesapplied?.feefranchiseebreakdown },
                                            { label: "Fee Reseller Breakdown", value: selectedPayment?.loanlatefeesapplied?.feeresellerbreakdown },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                    {value ? Number(value).toLocaleString() : "N/A"}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedPayment && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Apply ID", value: selectedPayment?.loanlatefeesapplied?.applyid },
                                                { label: "Late Fee ID", value: selectedPayment?.loanlatefeesapplied?.latefeeid },
                                                { label: "User ID", value: selectedPayment?.loanlatefeesapplied?.userid },
                                                { label: "Payment ID", value: selectedPayment?.loanlatefeesapplied?.paymentid },
                                                { label: "Confirmation Time", value: selectedPayment?.loanlatefeesapplied?.confirmationtime || "N/A" },
                                                { label: "Confirmation Ref No", value: selectedPayment?.loanlatefeesapplied?.confirmationrefno || "N/A" },
                                                { label: "Currency Code", value: selectedPayment?.loanlatefeesapplied?.currcode || "N/A" },
                                                { label: "Status", value: selectedPayment?.loanlatefeesapplied?.status === "1" ? "Confirmed" : "Not Confirmed" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Amount Applied", value: selectedPayment?.loanlatefeesapplied?.amountapplied },
                                                { label: "Tax Amount Breakdown", value: selectedPayment?.loanlatefeesapplied?.taxamountbreakdown },
                                                { label: "Fee System Breakdown", value: selectedPayment?.loanlatefeesapplied?.feesystembreakdown },
                                                { label: "Fee External Breakdown", value: selectedPayment?.loanlatefeesapplied?.feeexternalbreakdown },
                                                { label: "Fee Franchisee Breakdown", value: selectedPayment?.loanlatefeesapplied?.feefranchiseebreakdown },
                                                { label: "Fee Reseller Breakdown", value: selectedPayment?.loanlatefeesapplied?.feeresellerbreakdown },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value ? Number(value).toLocaleString() : "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
            
        </Box>
    )

}

export default GroupLoansLateFeePayments;